import React, { useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link, useNavigate } from "react-router-dom";
import { base_url } from "./AdminUsers";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

const Slider = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [sliders, setSliders] = useState([]);
  const [filteredSliders, setFilteredSliders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedSliders, setSelectedSliders] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [sliderToDelete, setSliderToDelete] = useState(null);
  const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  // New state variables for search and pagination
  const [searchTerm, setSearchTerm] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchSliders = async () => {
    const auth = localStorage.getItem("admin");
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${base_url}/api/webapi/fetchBannerAction`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      
      if (response.data.success) {
        setSliders(response.data.data.result);
        setFilteredSliders(response.data.data.result);
      } else {
        throw new Error("Failed to fetch sliders");
      }
    } catch (error) {
      console.error("Error fetching sliders:", error);
      setError("Failed to load sliders. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  // Apply search filter whenever searchTerm changes
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSliders(sliders);
    } else {
      const filtered = sliders.filter(slider => 
        slider.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slider.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
        slider.type.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredSliders(filtered);
    }
    // Reset to first page when search changes
    setCurrentPage(1);
  }, [searchTerm, sliders]);

  // Handle individual checkbox selection
  const handleCheckboxChange = (sliderId) => {
    setSelectedSliders(prev => {
      if (prev.includes(sliderId)) {
        return prev.filter(id => id !== sliderId);
      } else {
        return [...prev, sliderId];
      }
    });
  };

  // Handle "select all" checkbox for the current page
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders(prevSelected => {
        const nonPageIds = prevSelected.filter(id => !currentPageIds.includes(id));
        return [...nonPageIds, ...currentPageIds];
      });
    } else {
      const currentPageIds = paginatedSliders.map(slider => slider.id);
      setSelectedSliders(prevSelected => 
        prevSelected.filter(id => !currentPageIds.includes(id))
      );
    }
  };

  // Handle edit button click
  const handleEdit = (sliderId) => {
    navigate(`/admin/editSlider/${sliderId}`);
  };

  // Handle delete button click
  const handleDeleteClick = (slider) => {
    setSliderToDelete(slider);
    setShowDeleteModal(true);
  };

  // Handle bulk delete button click
  const handleBulkDeleteClick = () => {
    if (selectedSliders.length > 0) {
      setShowBulkDeleteModal(true);
    } else {
      alert("Please select at least one slider to delete");
    }
  };

  // Confirm single slider deletion
  const confirmDelete = async () => {
    if (!sliderToDelete) return;
    
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/deleteBannerAction`,
        { id: sliderToDelete.id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      
      if (response.data.success) {
        // Remove from selected sliders if it was selected
        setSelectedSliders(prev => prev.filter(id => id !== sliderToDelete.id));
        // Refresh the sliders list
        fetchSliders();
        
      } else {
        alert("Failed to delete slider: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting slider:", error);
      alert("An error occurred while deleting the slider. Please try again.");
    } finally {
      setShowDeleteModal(false);
      setSliderToDelete(null);
    }
  };

  // Confirm bulk deletion
  const confirmBulkDelete = async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(
        `${base_url}/api/webapi/bulkDeleteBannerAction`,
        { ids: selectedSliders },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      
      if (response.data.success) {
        // Refresh the sliders list
        fetchSliders();
        setSelectedSliders([]);
        
      } else {
        alert("Failed to delete sliders: " + response.data.message);
      }
    } catch (error) {
      console.error("Error deleting sliders:", error);
      alert("An error occurred while deleting the sliders. Please try again.");
    } finally {
      setShowBulkDeleteModal(false);
    }
  };

  // Handle change in entries per page
  const handleEntriesPerPageChange = (e) => {
    setEntriesPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1); // Reset to first page when changing entries per page
  };

  // Calculate pagination
  const indexOfLastSlider = currentPage * entriesPerPage;
  const indexOfFirstSlider = indexOfLastSlider - entriesPerPage;
  const paginatedSliders = filteredSliders.slice(indexOfFirstSlider, indexOfLastSlider);
  const totalPages = Math.ceil(filteredSliders.length / entriesPerPage);

  // Check if current page sliders are all selected
  const areAllCurrentPageSelected = 
    paginatedSliders.length > 0 && 
    paginatedSliders.every(slider => selectedSliders.includes(slider.id));


    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Slider
          </h1>
          
          <button
            onClick={handleBulkDeleteClick}
            className="btn btn-danger btn-add-new red_btn"
            disabled={selectedSliders.length === 0}
          >
            <i className="fa fa-trash"></i> <span>Bulk Delete</span>
          </button>
          
          <div className="pull-right topright_buttons ">
            <Link
              to="/admin/addSlider"
              className="btn btn-success btn-add-new red_btn"
            >
              <i className="fa fa-plus"></i> <span>Add New</span>
            </Link>
          </div>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row w-100">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    <form>
                      <div className="d-flex justify-content-between mx-4">
                        <div className="d-flex align-items-center">
                          <label className="me-2">Show</label>
                          <select 
                            className="form-select me-2" 
                            style={{ width: 'auto' }}
                            value={entriesPerPage}
                            onChange={handleEntriesPerPageChange}
                          >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                          <label>entries</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="me-2">Search:</label>
                          <input 
                            type='text' 
                            className="form-control" 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Search..."
                          />
                        </div>
                      </div>
                    </form>
                    <div className="mt-3 w-100">
                      {isLoading ? (
                        <p>Loading sliders...</p>
                      ) : error ? (
                        <p className="text-danger">{error}</p>
                      ) : (
                        <>
                          <table id="dataTable" className="table table-responsive-sm table-hover">
                            <thead>
                              <tr>
                                <th className="text-center">
                                  <input 
                                    type='checkbox' 
                                    name="all"
                                    onChange={handleSelectAll}
                                    checked={areAllCurrentPageSelected && paginatedSliders.length > 0}
                                  />
                                </th>
                                <th className="text-center">Title</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Type</th>
                                <th className="text-center">Image</th>
                                <th className="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paginatedSliders.length > 0 ? (
                                paginatedSliders.map((slider) => (
                                  <tr key={slider.id}>
                                    <td className="text-center">
                                      <input 
                                        type='checkbox'
                                        checked={selectedSliders.includes(slider.id)}
                                        onChange={() => handleCheckboxChange(slider.id)}
                                      />
                                    </td>
                                    <td>{slider.title}</td>
                                    <td>{slider.status}</td>
                                    <td>{slider.type}</td>
                                    <td>
                                      {slider.attachment && (
                                        <img 
                                          src={`${base_url}${slider.attachment}`} 
                                          alt={slider.title} 
                                          style={{ maxWidth: '100px', maxHeight: '60px' }} 
                                        />
                                      )}
                                    </td>
                                    <td className="d-flex gap-2 justify-content-end">
                                      <button 
                                        className="btn btn-primary"
                                        onClick={() => handleEdit(slider.id)}
                                      >
                                        <i className="fa fa-edit"></i> Edit
                                      </button>
                                      <button 
                                        className="btn btn-danger red_btn"
                                        onClick={() => handleDeleteClick(slider)}
                                      >
                                        <i className="fa fa-trash"></i> Delete
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="text-center">No sliders found</td>
                                </tr>
                              )}
                            </tbody>
                          </table>

                          {/* Pagination Controls */}
                          {filteredSliders.length > 0 && (
                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div>
                                Showing {indexOfFirstSlider + 1} to {Math.min(indexOfLastSlider, filteredSliders.length)} of {filteredSliders.length} entries
                              </div>
                              <div>
                                <button 
                                  className="btn btn-secondary me-2"
                                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                  disabled={currentPage === 1}
                                >
                                  Previous
                                </button>
                                <button
                                  className="btn btn-secondary"
                                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                  disabled={currentPage === totalPages}
                                >
                                  Next
                                </button>
                              </div>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Single Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the slider "{sliderToDelete?.title}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Bulk Delete Confirmation Modal */}
      <Modal show={showBulkDeleteModal} onHide={() => setShowBulkDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Bulk Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete {selectedSliders.length} selected slider(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowBulkDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmBulkDelete}>
            Delete All Selected
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Slider;